import { Button, Card } from 'antd';
import FilePreview from './file-preview/file-preview';
interface FileSelectionCardProps {
  files: Array<{
    type: string;
    label: string;
    fileName: string;
  }>;
  selectedFilesMap: SelectedFilesMap;
  onFileSelect: (fileType: string) => void;
  currentFileSelection: string;
  onCancel: () => void;
  onGenerateDocument: () => void;
  isProcessingMergingPdfs: boolean;
  title: string;
}

export interface SelectedFileInfo {
  name: string;
  url: string;
  type: string;
  caseType: string;
  caseId: string;
}

export interface SelectedFilesMap {
  [key: string]: SelectedFileInfo | null;
}

const FileSelectionCard: React.FC<FileSelectionCardProps> = (props) => (
  <Card title={props.title} >
    {props.files.map(({ type, label, fileName }) => (
      <div
        key={type}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '30px',
          minWidth: 325,
        }}
      >
        <FilePreview fileUrl={props.selectedFilesMap[type]?.url ?? ''} fileName={fileName} fileType={props.selectedFilesMap[type]?.type ?? ''} />
        <Button type={props.currentFileSelection === type ? 'primary' : 'default'} onClick={() => props.onFileSelect(type)}>
          {label}
        </Button>
      </div>
    ))}
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '80px'
      }}
    >
      <Button onClick={props.onCancel} disabled={props.isProcessingMergingPdfs}>
        Cancel
      </Button>
      <Button type="primary" onClick={props.onGenerateDocument} loading={props.isProcessingMergingPdfs}>
        Generate Document
      </Button>
    </div>
  </Card>
);

export default FileSelectionCard;
